// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-parent-height {
  position: relative;
  height: 100%;
}
.ant-table-parent-height > .ant-spin-nested-loading {
  position: absolute;
  inset: 0;
}
.ant-table-parent-height > .ant-spin-nested-loading > .ant-spin-container {
  position: absolute;
  inset: 0;
}
.ant-table-parent-height > .ant-spin-nested-loading > .ant-spin-container > .ant-table {
  position: absolute;
  inset: 0;
  overflow-y: auto;
}
.ant-table-parent-height > .ant-spin-nested-loading > .ant-spin-container > .ant-table > .ant-table-container > .ant-table-content > table > thead {
  position: sticky;
  top: 0;
  z-index: 5;
}
.ant-table-parent-height > .ant-spin-nested-loading > .ant-spin-container > .ant-table > .ant-table-container > .ant-table-content > table > tbody > tr.ant-table-placeholder > td {
  position: absolute;
  inset: 64px 0 0 0;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/gui/nodepkg/antd/table/index.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;AACJ;AAHA;EAKQ,kBAAA;EACA,QAAA;AACR;AAPA;EASY,kBAAA;EACA,QAAA;AACZ;AAXA;EAagB,kBAAA;EACA,QAAA;EACA,gBAAA;AAChB;AAhBA;EAmBwB,gBAAA;EACA,MAAA;EACA,UAAA;AAAxB;AArBA;EAyBwB,kBAAA;EACA,iBAAA;EACA,YAAA;AADxB","sourcesContent":[".ant-table-parent-height {\n    position: relative;\n    height: 100%;\n\n    > .ant-spin-nested-loading {\n        position: absolute;\n        inset: 0;\n\n        > .ant-spin-container {\n            position: absolute;\n            inset: 0;\n\n            > .ant-table {\n                position: absolute;\n                inset: 0;\n                overflow-y: auto;\n\n                > .ant-table-container > .ant-table-content > table {\n                    > thead {\n                        position: sticky;\n                        top: 0;\n                        z-index: 5;\n                    }\n\n                    > tbody > tr.ant-table-placeholder > td {\n                        position: absolute;\n                        inset: 64px 0 0 0;\n                        border: none;\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
